<template>
    <content-component>
        <template v-slot:table_create_button>
            <button class="btn custom-btn-02 w-100" @click="open_form_modal()">
                <i class="fas fa-plus"></i>
                Tentang Kami
            </button>
        </template>
        <template v-slot:content_body>
            <div class="row g-3" v-if="data.length">
                <div v-for="(about, index) in data" :key="index" class="col-12 col-lg-4">
                    <div class="rounded shadow-sm">
                        <div class="custom-image-warpper position-relative" v-viewer="{toolbar: false, navbar: false, keyboard: false}">
                            <img :src="about.image_url" alt="about-image">
                        </div>
                        <div class="d-flex justify-content-between custom-upload-preview-button">
                            {{ about.title }}
                            <div class="dropdown">
                                <button class="btn custom-btn-unborder-02 py-0" type="button" :id="`dropdownAbout${about.id}`" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <ul class="dropdown-menu" :aria-labelledby="`dropdownAbout${about.id}`">
                                    <li><span class="dropdown-item" @click="open_form_modal(about)">Ubah</span></li>
                                    <li><span class="dropdown-item" @click="delete_data(about.id)">Hapus</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="w-100 p-3 text-center">No Data.</div>
            </div>
        </template>
    </content-component>
    <about-form-modal ref="aboutFormModal" @close="close_modal"/>
</template>

<script>
	import ContentComponent from '@/components/external/ContentComponent'
    import AboutFormModal from './AboutFormModal'
    import { mapGetters } from 'vuex'
    import Swal from 'sweetalert2'

	export default {
        components: {
            'content-component': ContentComponent,
            'about-form-modal': AboutFormModal,
        },
        computed: {
            ...mapGetters({
                data: 'about/getAbout',
            }),
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                this.$store.dispatch('about/getAbout')
            },
            open_form_modal(value){
                this.$refs.aboutFormModal.open_modal(value)
            },
            close_modal(value){
                if(value){
                    this.init()
                }
            },
            delete_data(id){
                let parent = this
                Swal.fire({
                    icon: 'warning',
                    title: 'Apakah anda yakin ingin menghapus data ini?',
                    reverseButtons: true,
                    showCancelButton: true,
                    cancelButtonText: parent.$root.swal('cancelButtonText'),
                    confirmButtonColor: parent.$root.swal('errorButtonColor'),
                    confirmButtonText: parent.$root.swal('deleteButtonText'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        parent.$store.dispatch('about/deleteAbout', id).then((response) => {
                            if(response.status){
                                parent.init()
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Berhasil menghapus data',
                                    confirmButtonColor: parent.$root.swal('confirmButtonColor'),
                                    confirmButtonText: parent.$root.swal('doneButtonText'),
                                })
                            }
                        })
                    }
                })
            },
        }
	}
</script>